import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-marca-agua',
  templateUrl: './marca-agua.component.html',
  styleUrls: ['./marca-agua.component.scss']
})
export class MarcaAguaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
